import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const Route = createFileRoute("/cuenta/registro")({
  head: () => ({ meta: [{ title: "Crear cuenta — Truck Company Center" }, { name: "robots", content: "noindex" }] }),
  component: Registro,
});

function Registro() {
  const nav = useNavigate();
  const sp = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
  const [email, setEmail] = useState(sp?.get("email") ?? "");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [duplicate, setDuplicate] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setDuplicate(false);
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: { emailRedirectTo: `${window.location.origin}/cuenta` },
    });
    setLoading(false);
    if (error) {
      const msg = error.message.toLowerCase();
      if (msg.includes("already") || msg.includes("registered") || msg.includes("exists")) {
        setDuplicate(true);
        return;
      }
      toast.error(error.message);
      return;
    }
    toast.success("Cuenta creada. Revisa tu email para confirmar.");
    nav({ to: "/cuenta/login" });
  }

  return (
    <div className="mx-auto max-w-md px-4 py-16 md:px-6">
      <h1 className="font-display text-3xl font-semibold text-foreground">Crear cuenta</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        Usa el mismo email que usaste al hacer tu pedido para que podamos vincular tus compras automáticamente.
      </p>

      <form onSubmit={submit} className="mt-6 space-y-3 rounded-xl border border-hairline bg-surface p-6">
        <div>
          <Label className="text-xs text-muted-foreground">Email</Label>
          <Input className="bg-surface-2 border-hairline" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <p className="mt-1 text-[11px] text-muted-foreground">Usa el mismo email de tu pedido para que podamos vincular tus compras.</p>
        </div>
        <div>
          <Label className="text-xs text-muted-foreground">Contraseña (mínimo 6 caracteres)</Label>
          <Input className="bg-surface-2 border-hairline" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>

        {duplicate && (
          <div className="rounded-md border border-primary/40 bg-primary/10 p-3 text-xs text-foreground">
            Ya existe una cuenta con este email.{" "}
            <Link to="/cuenta/login" className="underline">Iniciar sesión</Link> o{" "}
            <Link to="/cuenta/recuperar" className="underline">recuperar contraseña</Link>.
          </div>
        )}

        <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
          {loading ? "..." : "Crear cuenta"}
        </Button>
      </form>

      <div className="mt-4 text-center text-xs">
        <Link to="/cuenta/login" className="text-muted-foreground hover:text-foreground">¿Ya tienes cuenta? Iniciar sesión</Link>
      </div>
    </div>
  );
}
